import {Component, inject, OnInit} from '@angular/core';
import {CommonModule, Location} from '@angular/common';
import {ActivatedRoute} from "@angular/router";
import {DxLoadPanelModule, DxScrollViewModule, DxDataGridModule, DxTextBoxComponent} from "devextreme-angular";
import {PurchaseOrdersClient, PurchaseOrderDto, PurchaseOrderItemDto, PurchaseOrderStatus} from '@services';
import notify from "devextreme/ui/notify";
import {Observable, of} from "rxjs";
import {catchError, filter, map, shareReplay, switchMap, tap} from "rxjs/operators";
import {GridPageComponent} from "../../../common/grid-page.component";
import {CapitalCasePipe} from "../../../../pipes/capital-case.pipe";
import EnumUtils from "../../../../shared/enum-utils";
import { PurchaseOrderItemsComponent } from './components/purchase-order-items/purchase-order-items.component';

@Component({
  selector: 'app-purchase-order',
  standalone: true,
    imports: [
        CommonModule,
        DxLoadPanelModule,
        DxScrollViewModule,
        DxDataGridModule,
        DxTextBoxComponent,
        CapitalCasePipe,
        PurchaseOrderItemsComponent
    ],
  templateUrl: './purchase-order.component.html',
  styles: [
      `.view-wrapper-scroll {
          height: calc(100vh - 150px);
      }`
  ]
})
export class PurchaseOrderComponent extends GridPageComponent<PurchaseOrderItemDto> implements OnInit {
    private route = inject(ActivatedRoute);
    private location = inject(Location);
    private poClient = inject(PurchaseOrdersClient);

    protected isLoading = false;
    protected purchaseOrder$!: Observable<PurchaseOrderDto>;

    constructor() {
        super();
        this.init(PurchaseOrderItemDto);
    }

    ngOnInit(): void {
        this.purchaseOrder$ = this.route.paramMap.pipe(
            map(params => params.get('number')),
            tap(number => {
                if (!number) {
                    this.location.back();
                } else {
                    this.isLoading = true;
                }
            }),
            filter((number): number is string => !!number),
            switchMap(number => this.poClient.getPurchaseOrder(number).pipe(
                catchError(() => {
                    notify('Failed to load purchase order', 'error', 3000);
                    this.location.back();
                    return of(null as any);
                })
            )),
            tap(() => this.isLoading = false),
            shareReplay(1)
        );
    }

    customizeSum(data: any) {
        return `Total: ${data.value}`;
    }

    protected getStatusBadgeClass(status: PurchaseOrderStatus): string {
        return EnumUtils.getPurchaseStatusBadgeClass(status);
    }
}
